/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
/**

## Media Block / Content

This is the content section of the [Media Block](../media-block.html) component.

### Contextual Components

| Description | Contextual Component |
| --- | --- |
| Headline [Primary,Secondary] | [media-block/content](./media-block/section.html) |
| Area | [media-block/media](./media-block/section.html) |
| Button [Primary,Secondary] | [media-block/button](./media-block/button.html) |

### Parameters
@param {string} [theme="dark"] 'light' or 'dark'. Controls the color of text and buttons provided to the content block
**/

import Component from '@ember/component';
import { computed } from '@ember/object';
export const MEDIA_BLOCK_CONTENT_THEME = {
  LIGHT: 'light',
  DARK: 'dark'
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['media-block__content'],
  classNameBindings: ['contentThemeClass'],
  attributeBindings: ['data-test-media-block-content'],
  'data-test-media-block-content': true,
  contentThemeClass: computed('theme', function () {
    if (this.theme === MEDIA_BLOCK_CONTENT_THEME.LIGHT) {
      return 'media-block__content--theme-light';
    } else {
      return '';
    }
  })
});